























import { Component, Vue } from "vue-property-decorator";

import QueueInfo from "@/components/HomeWidgets/QueueInfo.vue";
import TopActors from "@/components/HomeWidgets/TopActors.vue";
import UnwatchedActors from "@/components/HomeWidgets/UnwatchedActors.vue";
import Stats from "@/components/HomeWidgets/Stats.vue";
import Scan from "@/components/HomeWidgets/Scan.vue";
//import SearchTimes from "@/components/HomeWidgets/SearchTimes.vue";
import ActorLabelUsage from "@/components/HomeWidgets/ActorLabelUsage.vue";
import SceneLabelUsage from "@/components/HomeWidgets/SceneLabelUsage.vue";
import RemainingTime from "@/components/HomeWidgets/RemainingTime.vue";

@Component({
  components: {
    QueueInfo,
    TopActors,
    UnwatchedActors,
    Stats,
    Scan,
    //SearchTimes,
    ActorLabelUsage,
    SceneLabelUsage,
    RemainingTime,
  },
})
export default class Home extends Vue {}
